// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__PBpMG"};


//////////////////
// WEBPACK FOOTER
// ./components/styles/app.scss
// module id = 7ETb
// module chunks = 0